





import { Component, Vue, Prop } from "vue-property-decorator";
import Common from "../components/login/common_new.vue";
@Component({
  components: {
    Common
  },
})
export default class Name extends Vue {
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
}
